<template>
    <ul class="flex flex-col xs:flex-row items-center space-y-1 space-x-0 xs:space-y-0 xs:space-x-4 lg:space-x-6 xl:space-x-10">
        <landing-nav-item @click="show('about-us')">
            {{ $t('nav.about') }}
        </landing-nav-item>

        <landing-nav-item @click="showHome('plans')">
            {{ $t('nav.plans') }}
        </landing-nav-item>

        <landing-nav-item @click="show('why-c2c')">
            {{ $t('nav.why') }}
        </landing-nav-item>

        <landing-nav-item @click="show('faq')">
            {{ $t('nav.faq') }}
        </landing-nav-item>

        <landing-nav-item>
            <a href="/how-to">
                {{ $t('nav.how-to') }}
            </a>
        </landing-nav-item>

        <landing-nav-item @click="openContactModal">
            {{ $t('Contact Us') }}
        </landing-nav-item>
    </ul>
</template>

<script>
import { scrollIntoView } from 'scroll-js';
import LandingNavItem from './landing-nav-item.vue';

export default {
    components: {
        LandingNavItem,
    },

    props: {
        on_home: { default: true },
        home_route: { default: '/' },
    },

    data() {
        return {
            show_contact_us: false,
        }
    },

    methods: {
        scrollTo(id) {
            scrollIntoView(document.getElementById(id), document.body, {
                behavior: 'smooth',
            }).then(() => {
                // done scrolling document's body to show myElement
            });
        },
        show(section) {
            if (this.on_home || document.getElementById(section)) {
                this.scrollTo(section);
            } else {
                window.location = this.home_route + '#' + section;
            }
        },
        showHome(section) {
            if (this.on_home) {
                this.scrollTo(section);
            } else {
                window.location = this.home_route + '#' + section;
            }
        },
        openContactModal() {
            this.$modal.show('contact-us-modal');
        },
    },
}
</script>
